<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i">
<p class="fmhead">PRAISE FOR JACK HIGGINS AND HIS BESTSELLING NOVELS …</p>
<p class="fmhead1"><span class="bold">ANGEL OF DEATH</span></p>
<p class="noindent"><span class="bold">Jack Higgins’s electrifying bestseller—a mysterious terrorist group plots an assassination that will plunge Ireland into civil war …</span></p>
<p class="noindent1">“Pulsing excitement … Higgins makes the pages fly.”</p>
<p class="right"><em class="italic">—New York Daily News</em></p>
<p class="noindent1">“Jack Higgins has a new thriller, and like its long list of predecessors, it’s a terrific read.”</p>
<p class="right">—Associated Press</p>
<p class="noindent1">“An exciting yarn … hurtles from one thrill to the next.”</p>
<p class="right"><em class="italic">—Publishers Weekly</em></p>
<p class="noindent1">“As always with Higgins, the action never stops.”</p>
<p class="right"><em class="italic">—San, Francisco Examiner</em></p>
<p class="noindent1">“A crackling good read … A thrilling confrontation … Jack Higgins has been writing page-turners for more than thirty years now, and with <em class="italic">Angel of Death</em> he comes through with another top-drawer thriller.”</p>
<p class="right"><em class="italic">—Virginian Pilot</em></p>
<p class="noindent1">“A page-turner … an exciting read that will surely become a bestseller. Higgins once again has pulled it off.”</p>
<p class="right"><em class="italic">—The Chattanooga Free Press</em></p>
<p class="noindent1">“A powerful novel crafted by a master of the game. In <em class="italic">Angel of Death,</em> Jack Higgins once again proves that he is on par with the best thriller writers of the day.”</p>
<p class="right"><em class="italic">—Back Channels</em></p>
<p class="noindent1">“A gripping story without a single dead spot.”</p>
<p class="right"><em class="italic">—St. Petersburg Times</em></p>
<p class="noindent1">“A convincing scenario … Another four-star thriller.”</p>
<p class="right"><em class="italic">—Dayton Daily News</em></p>
<p class="noindent1">“Superb.”</p>
<p class="right"><em class="italic">—Minneapolis Star Tribune</em></p>
</a><p class="fmhead1"><a id="page_i"></a><a id="page_ii"><span class="bold">ON DANGEROUS GROUND</span></a></p><a id="page_ii">
<p class="noindent"><span class="bold">Jack Higgins’s explosive thriller—the desperate search for a secret document that could change the fate of Hong Kong, China, and the world …</span></p>
<p class="noindent1">“It’s a whirlwind of action, with a hero (Sean Dillon) who can out-Bond old James with one hand tied behind his back … It’s told in the author’s best style, with never a pause for breath.”</p>
<p class="right"><em class="italic">—New York Times Book Review</em></p>
<p class="noindent1">“Engaging … Jack Higgins knows how to entertain, and entertain he does with <em class="italic">On Dangerous Ground.”</em></p>
<p class="right"><em class="italic">—Baton Rouge Magazine</em></p>
<p class="noindent1">“This tale moves with a brisk and heady pace.”</p>
<p class="right"><em class="italic">—Roanoke Times &amp; World News</em></p>
<p class="noindent1">“A powerhouse tale of action and adventure.”</p>
<p class="right"><em class="italic">—Tampa Tribune-Times</em></p>
<p class="fmhead1"><span class="bold">SHEBA</span></p>
<p class="noindent"><span class="bold">His most powerful novel of Nazi intrigue—the shattering story of an archaeologist who discovers a legendary temple … and a Nazi plot to turn the landmark into Hitler’s secret stronghold.</span></p>
<p class="noindent1">“A seasoned pro … Mr. Higgins knows how to tell a story!”</p>
<p class="right"><em class="italic">—New York Times Book Review</em></p>
<p class="noindent1">“When it comes to thriller writers, one name stands well above the crowd—Jack Higgins.”</p>
<p class="right">—Associated Press</p>
<p class="noindent1">“The master’s master of spycraft storytelling.”</p>
<p class="right">—UPI</p>
</a><p class="fmhead1"><a id="page_ii"></a><a id="page_iii"><span class="bold">THUNDER POINT</span></a></p><a id="page_iii">
<p class="noindent"><span class="bold">The shattering bestseller about the search for Martin Bormann’s missing files—in a sunken U-boat on the bottom of the Caribbean…</span></p>
<p class="noindent1">“Dramatic … authentic … one of the author’s best.”</p>
<p class="right"><em class="italic">—New York Times</em></p>
<p class="noindent1">“A rollicking adventure that twists and turns …”</p>
<p class="right"><em class="italic">—San Diego Union-Tribune</em></p>
<p class="noindent1">“As in <em class="italic">The Eagle Has Landed,</em> Higgins builds his plot around an event that was widely conjectured at the end of World War II—that Martin Bormann escaped Adolf Hitler’s bunker in Berlin … Gripping.”</p>
<p class="right"><em class="italic">—Houston Chronicle</em></p>
<p class="noindent1">“Relentlessly paced … It’s a thriller all the way. Explosive, sinister, revealing … superb reading.”</p>
<p class="right"><em class="italic">—Macon Beacon</em></p>
<p class="noindent1">“Gripping … believable … fast-paced … continuous action.”</p>
<p class="right"><em class="italic">—Washington Post Book World</em></p>
<p class="fmhead1"><span class="bold">EYE OF THE STORM</span></p>
<p class="noindent"><span class="bold">A duel between two masters of espionage culminates in an attempted mortar attack on the British war cabinet—in this shocking thriller that blends fact and fiction …</span></p>
<p class="noindent1">“A heart-stopping cat-and-mouse game … spectacular and surprising.”</p>
<p class="right"><em class="italic">—Abilene Reporter-News</em></p>
<p class="noindent1">“A riveting story … as current as today’s headlines.”</p>
<p class="right"><em class="italic">—Columbia (SC) State</em></p>
<p class="noindent1">“Razor-edged … <em class="italic">Eye of the Storm</em> will give you an adrenaline high. It’s a winner.”</p>
<p class="right"><em class="italic">—Tulsa World</em></p>
<p class="noindent1">“When the final showdown looms, you can almost hear the clock ticking.”</p>
<p class="right"><em class="italic">—Lexington Herald-Ledger</em></p>
<p class="noindent1">“Will leave readers happily breathless.”</p>
<p class="right"><em class="italic">—Kirkus Reviews</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Praise.vue?2a41a23c